<template>
  <div :class="['jump-header']">
    <div class="header-left">
      <img src="~@/assets/image/icon_logo.png" alt="" />
      <span>花城+</span>
    </div>
    <div class="open-app" @click="downloadApp">打开APP</div>
  </div>
</template>

<script>
import { Dialog } from "vant";

export default {
  name: "JumpHeader",
  methods: {
    downloadApp() {
      Dialog.alert({
        message: "是否继续前往app",
        theme: "round-button",
      }).then(() => {
        const isAndroid =
          window.navigator.userAgent.indexOf("Android") >= 0 ? true : false;
        if (isAndroid) {
          window.location.href =
            "https://a.app.qq.com/o/simple.jsp?pkgname=com.hcj.gznews";
        } else {
          window.location.href =
            "https://apps.apple.com/us/app/花城/id682260500";
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.jump-header {
  position: fixed;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 45px;
  width: 100%;
  border-radius: 0 0 16px 16px;
  background: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  padding: 0 13px;
  z-index: 999;
  max-width: 768px;
  left: 50%;
  z-index: 999;
  transform: translateX(-50%);

  .header-left {
    display: flex;
    align-items: center;

    & > img {
      width: 35px;
      height: 35px;
      border-radius: 4px;
    }

    & > span {
      font-size: 16px;
      color: #d55555;
      margin-left: 10px;
    }
  }

  .open-app {
    width: 75px;
    height: 24px;
    border: 1px solid #d55555;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #d55555;
    font-size: 12px;
    letter-spacing: 1px;
    text-indent: 1px;
  }
}
</style>
